export const colorMap = {
    'PENDING': 'geekblue',
    'RUNNING': 'green',
    'FAIL': 'volcano'
};